var ComponentClassName;
(function (ComponentClassName) {
    ComponentClassName["ChangePassword"] = "amplify-accountsettings-changepassword";
    ComponentClassName["DeleteUser"] = "amplify-accountsettings-deleteuser";
})(ComponentClassName || (ComponentClassName = {}));

export { ComponentClassName };
